import React from "react";
import { Link } from "react-router-dom";
import { UncontrolledTooltip } from 'reactstrap';

const DetailsToolTip = (props) => {
    return (
        <>
            <Link to={props.to} onClick={props.onClick} className="text-dark"><i className="fa fa-info-circle mr-2" id='Show' aria-hidden="true"></i></Link>
            <UncontrolledTooltip placement={props.placement} target="Show">
                {props.title}
            </UncontrolledTooltip>
        </>
    )
}

export default DetailsToolTip;